import { render } from "./BulkProductGridTabs.vue?vue&type=template&id=0893d7a8"
import script from "./BulkProductGridTabs.vue?vue&type=script&lang=js"
export * from "./BulkProductGridTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__